import axios from 'axios';


export default {
    updateCourse(id, data) {
        const options = {
            method: 'PATCH',
            url: window.apiUrl + '/trial-course/' + id,
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    createCourse(data) {
        const options = {
            method: 'POST',
            url: window.apiUrl + '/trial-course',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    updateLesson(lessonId, data) {
        const options = {
            method: 'PATCH',
            url: window.apiUrl + '/trial-course/lesson/' + lessonId,
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    deleteVideo(id) {
        const options = {
            method: 'DELETE',
            url: window.apiUrl + '/trial-course/video/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    upsertVideo(data) {
        const options = {
            method: 'PUT',
            url: window.apiUrl + '/trial-course/video',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getTranscript(videoId) {
        const options = {
            method: 'GET',
            url: window.apiUrl + '/trial-transcript?videoId=' + videoId,            
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    upsertDeliverable(data) {
        const options = {
            method: 'PUT',
            url: window.apiUrl + '/trial-course/deliverable',
            data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    deleteDeliverable(id) {
        const options = {
            method: 'DELETE',
            url: window.apiUrl + '/trial-course/deliverable/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getCourses() {
        const options = {
            method: 'GET',
            url: window.apiUrl + '/trial-courses',
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },

    addDownload(data) {
        const options = {
            method: 'POST',
            url: window.apiUrl + '/trial-course/download',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    updateDownload(downloadId, data) {
        const options = {
            method: 'PATCH',
            url: window.apiUrl + '/trial-course/download/' + downloadId,
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    addMeeting(data) {
        const options = {
            method: 'POST',
            url: window.apiUrl + '/trial-course/meeting',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    updateMeeting(id, data) {
        const options = {
            method: 'PATCH',
            url: window.apiUrl + '/trial-course/meeting/' + id,
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    deleteMeeting(id) {
        const options = {
            method: 'DELETE',
            url: window.apiUrl + '/trial-course/meeting/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    updateInstance(id, data) {
        const options = {
            method: 'PATCH',
            url: window.apiUrl + '/trial-course-instance/' + id,
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    deleteInstance(id) {
        const options = {
            method: 'DELETE',
            url: window.apiUrl + '/trial-course-instance/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    createInstance(data) {
        const options = {
            method: 'POST',
            url: window.apiUrl + '/trial-course-instance',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    addIntroVideo(data) {
        const options = {
            method: 'POST',
            url: window.apiUrl + '/trial-intro-video',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    deleteIntroVideo(id) {
        const options = {
            method: 'DELETE',
            url: window.apiUrl + '/trial-intro-video/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    addNotification(data) {
        const options = {
            method: 'POST',
            url: window.apiUrl + '/trial-notification',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    updateNotification(data, id) {
        const options = {
            method: 'PATCH',
            url: window.apiUrl + '/trial-notification/' +id,
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    deleteNotification(id) {
        const options = {
            method: 'DELETE',
            url: window.apiUrl + '/trial-notification/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    deleteDownload(id) {
        const options = {
            method: 'DELETE',
            url: window.apiUrl + '/trial-course/download/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },

    getSubmissions(instanceId) {
        const options = {
            method: 'GET',
            url: window.apiUrl + '/trial-course-submissions/' + instanceId,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
}


// WEBPACK FOOTER //
// ./src/services/trial-courses/index.js